module.exports = __webpack_public_path__ + "img/3.bf2f5fdd.jpg";